


















































import { Component, Vue } from "vue-property-decorator";
import { API, Storage } from "aws-amplify";
import DropZone from '@/components/common/DropZone.vue';
import FileItem from '@/components/common/FileItem.vue';
import BasicInputForm from "@/components/forms/BasicInputForm.vue";

@Component({
    components: {
        DropZone,
        FileItem,
        BasicInputForm,
    }
})

export default class FileDrop extends Vue {
    /*
        @Prop()
        id!: string;

        @Prop()
        label!: string;

        @Prop()
        description!: string;

        @Prop()
        keyPrefix!: string;

        @Prop()
        dataValue!: string;

        @Prop()
        hideDetails!: boolean;

        @Prop({default: 30000000})
        sizeMax!: number;

        @Prop({default: false})
        outlined!: boolean;

        rules = [
            (value: any) => !value || value.size < this.sizeMax || 'Unable to upload file of that size. Max size is ' + this.sizeMax / 1000000 + 'MBs',
        ];

        file: File | null = null;

        value: any = null;
        previousFileText: any = null;

        private fileLink: any = null;
        private currentFileLink: any = null;

        $refs!: {
            fileInput: HTMLFormElement
        };
    */

    private files: File[] = [];
    private uploadProgress: { [key: string]: { state: string; percentage: number } } = {};
    private uploading = false;
    private uploadSuccess = false;
    private errorMessage = '';
    private resultKey: any = null;
    private nameDialog: boolean = false;
    private defaultName: any = {name: '', description: ''};
    private API_NAME = "Viewpoint360API";

    onFilesAdded(files: File[]) {
        this.files = [...files, ...this.files];
        this.defaultName = {name: files[0].name, description: 'Imported CSV on April 21, 2020'};
        this.nameDialog = true;
        this.$emit('nextStep', 2);
    }

    nameFile(payload: any) {
        this.defaultName = {name: payload.name, description: payload.description};
        console.log(this.defaultName);
        this.uploadFiles();
    }

    async uploadFiles() {
        this.uploading = true;
        this.uploadProgress = {};
        const promises: Promise<any>[] = [];
        this.files.forEach(file => {
            promises.push(this.sendRequest(file));
        });
        try {
            await Promise.all(promises);
            this.uploading = false;
            this.uploadSuccess = true;
        } catch (err) {
            console.log(err);
            this.uploading = false;
            this.errorMessage = err;
            // Just do this for now...
            this.uploadSuccess = true;
        }
    }

    sendRequest(file: File) {
        const key: string = `ingest/csv/${file.name}`;
        return Storage.put(key, file, {
                progressCallback(progress: any) {
                    this.uploadProgress[file.name] = {state: 'uploading', percentage: progress.loaded / progress.total}
                    this.uploadProgress = {...this.uploadProgress};
                    console.log(`Uploaded: ${progress.loaded}/${progress.total}`);
                },
            })
            .then((result: any) => {
                this.resultKey = result.key;
                console.log('this.resultKey');
                console.log(this.resultKey);
                const path = '/ingest/decision';
                const myInit = {
                    body: {
                        bucket: process.env.VUE_APP_STORAGE_S3_BUCKET,
                        key: `public/${result.key}`,
                        name: this.defaultName.name,
                        description: this.defaultName.description,
                        // dataSourceId: '',
                    }
                };

                API.post(this.API_NAME, path, myInit)
                    .then((result: any) => {
                        console.log(result);
                        this.$emit('decisionCreated', result);
                    })
                    .catch(err => console.log(err));

                this.uploadProgress[file.name] = {state: 'done', percentage: 100}
                this.uploadProgress = {...this.uploadProgress};
                this.clearFileList();
                this.$emit('nextStep', 3);
            })
            .catch(err => {
                this.uploadProgress[file.name] = {state: 'error', percentage: 0}
                this.uploadProgress = {...this.uploadProgress};
                console.log(err);
            });
    }

    clearFileList() {
        this.files = [];
        this.uploadSuccess = false;
    }

}
